import {
  SET_FREE_HTML_SECTIONS,
} from '../actions/sso';

export const initialState = {
  topFreeHtml: null,
  bottomFreeHtml: null,
};

const ACTIONS = {
  [SET_FREE_HTML_SECTIONS]: ({ state, action }) => ({
    ...state,
    topFreeHtml: action.topFreeHtml || null,
    bottomFreeHtml: action.bottomFreeHtml || null,
  }),
};

export default function sso(state = initialState, action) {
  return ACTIONS[action.type] ? ACTIONS[action.type]({ state, action }) : state;
}
